import apiProformaInvoices from './../../api/apiProformaInvoices'
import apiCars from "../../api/apiCars";

const state = {
    updateModal: false,
    deleteModal: false,
    deleteMultiModal: false,
    errorStatus: false,
    errorMessage: null,
    isLoading: false,
    validationErrors: {
        incoterm: null
    },
    proforma: {
        condition: null,
        currency: null,
        remarks: null,
        name: null,
        commission: null,
        inland_transport: null,
        result: null,
        issued_date: null,
        due_date: null,
        balance_due_usd: null,
        paid_amount: null,
        sub_total: null,
        deposit_applied: null,
        balance_due: null,
        shipping_type: null,
        incoterm: null,
        cost_in_usd: null,
        locked: null
    },
    isModalActive: false,
    activeModalCarId: null,
    query: {
        car_id: null,
        shipping_type: null,
        invoice_details_id: null
    },
    multiProforma: {},
    multiProformas: [],
    multiProformasLoading: false
}

const getters = {
    getProformaDeleteModalStatus: (state) => {
        return state.deleteModal
    },
    getMultiProformaDeleteModalStatus: (state) => {
        return state.deleteMultiModal
    },
    getProformaInvoice: (state) => {
        return state.proforma
    },
    getProformaInvoiceModalStatus: (state) => (carId) => {
        return state.isModalActive && state.activeModalCarId === carId
    },
    getProformaInvoiceErrorStatus: (state) => {
        return state.errorStatus
    },
    getProformaInvoiceErrorMessage: (state) => {
        return state.errorMessage
    },
    getProformaInvoiceLoadingStatus: (state) => {
        return state.isLoading
    },
    getProformaInvoiceQuery: (state) => {
        return state.query
    },
    getProformaInvoiceActiveModalCarId: (state) => {
        return state.activeModalCarId
    },
    getProformaInvoiceLockedStatus: (state) => {
        return state.proforma.locked !== null
    },
    getProformaInvoiceValidationErrors: (state) => {
        return state.validationErrors
    },
    getUpdateMultiProformaModal: (state) => {
        return state.updateModal
    },
    getMultiProformaFields: (state) => {
        return state.multiProforma
    },
    getMultiProformas: (state) => {
        return state.multiProformas
    },
    getMultiProformasLoading: (state) => {
        return state.multiProformasLoading
    }
}

const mutations = {
    setProforma: (state, newProforma) => {
        state.proforma = newProforma
    },
    setProformaFieldValue: (state, data) => {
        state.proforma[data.field] = data.value
    },
    setProformaInvoiceModalStatus: (state, newStatus) => {
        state.isModalActive = newStatus.status
        state.activeModalCarId = newStatus.carId
    },
    setProformaInvoiceErrorStatus: (state, newStatus) => {
        state.errorStatus = newStatus
    },
    setProformaInvoiceErrorMessage: (state, newMessage) => {
        state.errorMessage = newMessage
    },
    setProformaQueryFieldValue: (state, data) => {
        state.query[data.field] = data.value
    },
    setProformaInvoiceToDefault: (state) => {
        state.proforma = {
            id: null,
            invoice_details_id: null,
            condition: null,
            currency: null,
            remarks: null,
            name: null,
            commission: null,
            inland_transport: null,
            result: null,
            issued_date: null,
            due_date: null,
            balance_due_usd: null,
            paid_amount: null,
            sub_total: null,
            deposit_applied: null,
            balance_due: null,
            shipping_type: null,
            incoterm: null,
            cost_in_usd: null,
            locked: null
        }
    },
    setProformaInvoiceQueryToDefault: (state) => {
        state.query = {
            car_id: null,
            shipping_type: null,
            invoice_details_id: null
        }
    },
    setProformaInvoiceValidationErrors: (state, data) => {
        for (const [key, value] of Object.entries(data)) {
            state.validationErrors[key] = value
        }
    },
    setProformaInvoiceValidationErrorsToDefault: (state) => {
        state.validationErrors = {
            incoterm: null
        }
    },
    updateProformaDeleteModalStatus: (state, newStatus) => {
        state.deleteModal = newStatus
    },
    updateMultiProformaDeleteModalStatus: (state, newStatus) => {
        state.deleteMultiModal = newStatus
    },
    updateMultiProformaModal: (state, newStatus) => {
        state.updateModal = newStatus
    },
    updateMultiProformaFields: (state, data) => {
        state.multiProforma = data
    },
    setMultiProformas: (state, data) => {
        state.multiProformas = data
    },
    setMultiProformasLoading: (state, data) => {
        state.multiProformasLoading = data
    }
}

const actions = {
    calculateProformaInvoice: ({ commit, state, getters }) => {
        let subTotal = Number(getters.getProformaInvoiceTotalSaleAmount)
        let balanceDue = Number(subTotal) - Number(state.proforma.deposit_applied)
        let subCost = Number(getters.getProformaInvoiceTotalCostAmount);
        let cost = 0;
        let sale = 0;
        let profit = 0;

        if(state.proforma.id > 1018){

            if(state.proforma.car.is_usd && state.proforma.cost_in_usd === null){
                //cost = Math.round(Number(subCost) * Number(getters.getProformaInvoice.rate))
                cost = Number(Number(subCost) * Number(getters.getProformaInvoice.rate)).toFixed(2)
            }else if(state.proforma.car.is_usd && state.proforma.cost_in_usd !== null){
                cost = Number(subCost)
            }else if(!state.proforma.car.is_usd && state.proforma.cost_in_usd === null){
                cost = Number(subCost)
            }else if(!state.proforma.car.is_usd && state.proforma.cost_in_usd !== null){
                //cost = Math.round(Number(subCost) / Number(getters.getProformaInvoice.rate))
                cost = Number(Number(subCost) / Number(getters.getProformaInvoice.rate)).toFixed(2)
            }


            /* if(state.proforma.currency == 2 && state.proforma.cost_in_usd === null){
                 cost = Math.round(Number(subCost) * Number(getters.getProformaInvoice.rate))
             }else if(state.proforma.car.is_usd && state.proforma.cost_in_usd === null){
                 cost = Math.round(Number(subCost) * Number(getters.getProformaInvoice.rate))
             }else{
                 cost = Number(subCost)cost = Number(subCost)
             }*/
            //let cost = state.proforma.currency == 2 && state.proforma.cost_in_usd === null ? Math.round(Number(subCost) * Number(getters.getProformaInvoice.rate)) : Number(subCost)
            //let cost = state.proforma.cost_in_usd === null ? Number(getters.getProformaInvoiceTotalCostAmount)
            sale = state.proforma.currency == 2 &&  state.proforma.cost_in_usd === null ? Math.round(Number(subTotal) * Number(getters.getProformaInvoice.rate)) : Number(subTotal)
            profit = Number(sale) - Number(cost)
        }else{
            cost = Number(getters.getProformaInvoiceTotalCostAmount)
            sale = state.proforma.currency == 2 &&  state.proforma.cost_in_usd === null ? Math.round(Number(subTotal) * Number(getters.getProformaInvoice.rate)) : Number(subTotal)
            profit = Number(sale) - Number(getters.getProformaInvoiceTotalCostAmount)
        }

        commit('setProformaFieldValue', { field: 'cost', value: cost })
        commit('setProformaFieldValue', { field: 'sub_total', value: subTotal })
        commit('setProformaFieldValue', { field: 'sale', value: sale })
        commit('setProformaFieldValue', { field: 'balance_due', value: balanceDue })
        commit('setProformaFieldValue', { field: 'profit', value: profit })

    },
    changeProformaInvoiceModalStatus: ({ commit }, newStatus) => {
        commit('setProformaInvoiceModalStatus', newStatus)
    },
    changeProformaInvoiceFieldValue: ({ commit }, newValue) => {
        commit('setProformaFieldValue', newValue)
    },
    changeProformaInvoiceToDefault: ({ commit }) => {
        commit('setProformaInvoiceToDefault')
    },
    changeProformaInvoiceQueryToDefault: ({ commit }) => {
        commit('setProformaInvoiceQueryToDefault')
    },
    changeProformaInvoiceQueryFieldValue: ({ commit }, newValue) => {
        commit('setProformaQueryFieldValue', newValue)
    },
    checkProformaInvoice: ({ commit }, carId) => {
        commit('setProformaInvoiceErrorStatus', true)
        apiProformaInvoices
            .checkProformaInvoiceRequirements(carId)
            .then((response) => {
                commit('setProformaInvoiceErrorStatus', false)
            })
            .catch((error) => {
                commit('setProformaInvoiceErrorStatus', true)
                commit('setProformaInvoiceErrorMessage', error.response.data)
            })
    },
    fetchProformaInvoice: ({ commit , dispatch}, carId) => {
        commit('setProformaInvoiceErrorStatus', true)
        commit('setProformaInvoiceErrorMessage', null)
        apiProformaInvoices
            .proformaInvoiceRequest(carId)
            .then((response) => {
                commit('setProforma', response.data)
                dispatch('changeProformaInvoiceCostItems', {costs: response.data.costs, car: response.data.car})
                dispatch('changeProformaInvoiceSaleItems', response.data.sales)
                dispatch('changeProformaInvoiceTotalSaleAmount')
                dispatch('changeProformaInvoiceTotalCostAmount')
                commit('setProformaInvoiceErrorStatus', false)
                dispatch('calculateProformaInvoice')
            })
            .catch((error) => {
                console.log(error)
                commit('setProformaInvoiceErrorMessage', error.response.data)
            })
    },
    createProformaInvoice: ({state, dispatch, commit}) => {
        apiProformaInvoices
            .createNewProformaInvoice(state.query)
            .then((response) => {
                commit('setProforma', response.data)
                dispatch('changeProformaInvoiceCostItems', {costs: response.data.costs, car: response.data.car})
                dispatch('changeProformaInvoiceSaleItems', response.data.sales)
                dispatch('changeProformaInvoiceTotalSaleAmount')
                dispatch('changeProformaInvoiceTotalCostAmount')
            })
            .catch((error) => console.log(error))

    },
    saveProformaInvoice: ({commit, dispatch, state, getters }) => {
        commit('setProformaInvoiceValidationErrorsToDefault')
        let data = {
            id: state.proforma.id,
            proforma: state.proforma,
            cost_items: getters.getProformaInvoiceCostItems,
            sale_items: getters.getProformaInvoiceSaleItems
        }
        apiProformaInvoices
            .updateProformaInvoiceRequest(data)
            .then((response) => {
                dispatch('fetchProformaInvoice', response.data.car_id)
            })
            .catch((error) => {
                console.log(error)
                if (error.response.status === 422) {
                    let data = JSON.parse(error.response.data)
                    commit('setProformaInvoiceValidationErrors', data)
                }
            })
    },
    downloadProformaInvoicePdf: ({ state })  => {
        apiProformaInvoices
            .proformaExportInPDFRequest(state.proforma.id)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                const name = Number(state.proforma.id).toString().padStart(6, 0)
                link.setAttribute('download', 'INV-'+ name + '.pdf')
                document.body.appendChild(link)
                link.click()
            })
            .catch((error) => console.log(error))
    },
    downloadProformaInvoiceExcel: ({ state })  => {
        apiProformaInvoices
            .proformaExportInEXCELRequest(state.proforma.id)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                const link = document.createElement('a')
                link.href = url
                const name = Number(state.proforma.id).toString().padStart(6, 0)
                link.setAttribute('download', 'INV-'+ name + '.xlsx')
                document.body.appendChild(link)
                link.click()
            })
            .catch((error) => console.log(error))
    },
    downloadMultiProformaInvoiceExcel: (context) => {
        const query = {
            cars_ids: context.getters.getShippingGroupCars
        }
        apiProformaInvoices
            .multiProformaExportInEXCELRequest(query)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'MULTI_INV.xlsx')
                document.body.appendChild(link)
                link.click()
            })
            .catch((error) => console.log(error))
    },
    changeProformaInvoiceValidationErrors: ({commit}, data) => {
        commit('setProformaInvoiceValidationErrors', data)
    },
    setProformaDeleteModalStatus: ({ commit }, newStatus) => {
        commit('updateProformaDeleteModalStatus', newStatus)
    },
    setMultiProformaDeleteModalStatus: ({ commit }, newStatus) => {
        commit('updateMultiProformaDeleteModalStatus', newStatus)
    },
    deleteInvoiceById: ({ commit, dispatch }, invoiceId) => {
        apiProformaInvoices
            .deleteProformaInvoiceRequest(invoiceId)
            .then((response) => {
                commit('updateProformaDeleteModalStatus', false);
                dispatch('fetchProfitSectionInvoicesWithQuery');
            })
            .catch(error => console.log(error))
    },
    deleteMultiInvoiceById: ({ commit, dispatch }, invoiceId) => {
        apiProformaInvoices
            .deleteMultiProformaInvoiceRequest(invoiceId)
            .then((response) => {
                commit('updateMultiProformaDeleteModalStatus', false);
                commit('updateMultiProformaModal', false)
                dispatch('getUserMultiProformas', response.data);
            })
            .catch(error => console.log(error))
    },
    getMultiProforma: ({ commit }, invoiceId) => {
        apiProformaInvoices
            .getMultiProformaRequest(invoiceId)
            .then((response) => {
                commit('updateMultiProformaFields', response.data);
                commit('updateMultiProformaModal', true)
            })
            .catch(error => console.log(error))
    },
    updateMultiProformaModal: ({commit}, status) => {
        commit('updateMultiProformaModal', status)
    },
    saveMultiProformaInvoice: ({ commit, dispatch }, multiProforma) => {
        apiProformaInvoices
            .saveMultiProformaInvoiceRequest(multiProforma)
            .then((response) => {
                dispatch('getUserMultiProformas', response.data);
                commit('updateMultiProformaModal', false)
            })
            .catch(error => console.log(error))
    },
    getUserMultiProformas: ({commit}, user_id) => {
        apiProformaInvoices
            .multiProformaInvoices(user_id)
            .then((response) => {
                this.isLoading = false;
                //this.multiProformas = response.data.data
                commit('setMultiProformas', response.data.data)
                commit('setMultiProformasLoading', false)
            })
            .catch((error) => {
                this.isLoading = false
            })
    },
    setMultiProformasLoading: ({commit}, status) => {
        commit('setMultiProformasLoading', status)
    }
}

export default { state, getters, mutations, actions }




// WEBPACK FOOTER //
// ./src/store/modules/proformaInvoice.js